<section class="ac-modal" *ngIf="treeNodeMap">
	<div class="header text-align-center text-28-bold" dcrHTMLKey="PORTFOLIO_STRUCTURE_TITLE">
		Portfolio Structure
	</div>
	<ac-view-blend-structure-table class="grid" [portChildrenMap]="treeNodeMap" [rootId]="portfolioId"></ac-view-blend-structure-table>
</section>
